import parseQueryString from "../helpers/parseQueryString";

export default class UtmStore {
  getCodes() {
    try {
      const item = sessionStorage.getItem("velaro_utm");

      if (!item) {
        return null;
      }

      return JSON.parse(item);
    } catch (err) {
      console.error(err);
      return null;
    }
  }
}

if (window.parent) {
  try {
    const utm: { [key: string]: string } = {};
    const params = parseQueryString(window.parent.location.search);

    Object.keys(params)
      .filter((x) => x.indexOf("utm_") === 0)
      .forEach((key) => {
        utm[key] = params[key];
      });

    if (Object.keys(utm).length > 0) {
      sessionStorage.setItem("velaro_utm", JSON.stringify(utm));
    }
  } catch (err) {
    console.error(err);
  }
}
